import { gql } from "@apollo/client";

export default gql`
  query GetCurrentUser {
    currentUser {
      id
      name
      registrationComplete
      featureAccesses {
        type
        slug
      }
      currentWorkspace {
        client {
          id
          actor {
            id
            nickname
          }
        }
        currentAccessGroup {
          id
          slug
        }
      }
      workspaces {
        client {
          id
        }
      }
    }
  }
`;
